var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[(this.isDataLoaded)?_c('div',{staticClass:"col-xl-8"},[_c('form-proposal',{attrs:{"locations":_vm.possibleLocations,"negotiation":this.negotiation,"quotation":this.quotation,"title":"Nueva propuesta"},on:{"submit":_vm.submitProposal}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }